 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddNewPlatform":"AddNewPlatform","ResetPassword":"ResetPassword","lang-ar-js":"lang-ar-js","lang-fr-js":"lang-fr-js"}[chunkId]||chunkId) + "." + {"AddNewPlatform":"03ea67ad","ResetPassword":"5f675964","chunk-000f9ec6":"3e33ed5a","chunk-173ac372":"fe014367","chunk-6c3750fe":"f5043360","chunk-19ffec8b":"7527faba","chunk-0bc74327":"9dd79017","chunk-523ed891":"7c3e38e6","chunk-5e39cf3e":"eaebf792","chunk-65b468ae":"3a109f1e","chunk-c382173e":"e16ae58a","chunk-3a4b59cf":"eb70b8ad","chunk-00aff3dc":"95ce4b90","chunk-2d0f1010":"84937fb6","chunk-739beacc":"1a3fc378","chunk-76392eac":"e2b5d048","chunk-09316e56":"93042ba0","chunk-0c208a24":"7fd0d813","chunk-0cd3a036":"1f009563","chunk-012a3980":"ba7f0de8","chunk-1e1b70ce":"6f19ca17","chunk-28e0a6d8":"1cd59e17","chunk-5d177b48":"2acc9ee5","chunk-34e639ce":"04778e2d","chunk-0eb28a83":"61822a6e","chunk-f4de09ea":"24124a01","chunk-71dec82a":"3a1b7f1e","chunk-74ecf879":"6646e7e7","chunk-d8049c4e":"589ffe8d","chunk-0ef001b7":"189be642","chunk-10f8e26c":"ca5d5605","chunk-1a029487":"f6780d23","chunk-28d8687e":"32dddb45","chunk-73f106a2":"ddbb3e4f","chunk-7d358f54":"b001a01e","chunk-ac36e800":"81c03ff3","chunk-35091448":"f37bfafb","chunk-4e3c30d6":"54d583d2","chunk-147c0f50":"126b9306","chunk-2608d10c":"533c10e4","chunk-4bc4f5dd":"f6873feb","chunk-5873f342":"f07c6cfc","chunk-5a392a6d":"1c616975","chunk-351ffa5a":"e51ae23f","chunk-630c91a8":"064845b6","chunk-fbd596f6":"e7637caf","chunk-5c19e750":"df4ea626","chunk-67b72cb9":"ba4def8c","chunk-44d1996e":"9d4473c7","chunk-13b66f3e":"79b944a9","chunk-0798af1c":"fa4f1aff","chunk-14f7ea66":"d8785f7c","chunk-164c7626":"8ab9b152","chunk-07164102":"68e11a23","chunk-526cb31d":"d2a8dce8","chunk-83fb632e":"159b8a94","chunk-1b7a2e22":"8d1d5b70","chunk-1d83229b":"69a2e8c8","chunk-1e857436":"8c5c48ba","chunk-1ff75b9c":"07d7023c","chunk-22ec8fae":"ce627ecf","chunk-249cfae6":"9e1711f3","chunk-28f60f38":"0ac0843f","chunk-3011d30a":"2baae320","chunk-31001712":"d94d1784","chunk-41eb90f0":"e219b208","chunk-470f6c2e":"a75afe3b","chunk-59d985be":"0190c0aa","chunk-5a0538ee":"49e5e710","chunk-5d3dd47e":"cd255be6","chunk-5e6b1b7f":"b11ac45f","chunk-6488a1af":"b0a39dc4","chunk-657f9006":"7d36af4e","chunk-65c3803c":"219032a8","chunk-65eabde3":"916cc5f2","chunk-00c58462":"86352561","chunk-020ee2cc":"dbbcfbf9","chunk-0967a420":"73a481e5","chunk-096a7f28":"607422d2","chunk-09c095d0":"f3cb459b","chunk-09c2608b":"b6f610ab","chunk-84886a88":"507b7222","chunk-0feebfce":"b62de857","chunk-1317f7ff":"9a89ec4c","chunk-15468e74":"c09bf3d6","chunk-0a4396f5":"497988c8","chunk-3f024ec1":"3cde60bc","chunk-47feed04":"8f693e03","chunk-1af11311":"47d2f4a4","chunk-23f8557c":"68eb897c","chunk-2a16855b":"10a71677","chunk-2d0c4c35":"19f53bf2","chunk-2d0cfc48":"539ea291","chunk-2d229624":"75544850","chunk-2d229bb6":"44b4aa66","chunk-417bd08e":"1ffefdf1","chunk-4b77a73a":"e2b5f79f","chunk-584ff47c":"118c6e57","chunk-5d8f1146":"d0e040b9","chunk-6629aea1":"cd159636","chunk-70dce6f7":"09233240","chunk-70f4c463":"77fbb42c","chunk-7265886b":"93c35f3a","chunk-7f2b860a":"f56ac0c3","chunk-875d1180":"cd05d0e2","chunk-a2594b04":"d9370b3c","chunk-d4ee21da":"914e4c59","chunk-ec8890b2":"2a5ea115","chunk-ecb72392":"aed7d0a6","chunk-71310779":"5ea105d2","chunk-8741dcfa":"eeb47e85","chunk-e98f3c76":"08e12ea3","chunk-7ada92d7":"2c6e335e","chunk-7b35a887":"acb9aacc","chunk-8a9cf9fe":"64e0be28","chunk-921365f2":"dd7e3fad","chunk-92a42972":"1bc1503a","chunk-953cde5a":"35c98c5e","chunk-a7961be2":"b9b6f1de","chunk-1613100e":"61117663","chunk-73f6c48b":"55415b85","chunk-096579d6":"deb5d11f","chunk-59f7bbd5":"f909cdbd","chunk-ad88a7ca":"d5314369","chunk-fc12ec66":"086f3121","chunk-f405f72e":"bf152bbf","chunk-00daf07a":"b66fac3f","chunk-3e8da645":"59477709","chunk-7285809e":"644abf48","chunk-ea7b0888":"ea962b73","lang-ar-js":"998aa4d8","lang-fr-js":"be4df629"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ResetPassword":1,"chunk-173ac372":1,"chunk-6c3750fe":1,"chunk-19ffec8b":1,"chunk-0bc74327":1,"chunk-523ed891":1,"chunk-5e39cf3e":1,"chunk-65b468ae":1,"chunk-c382173e":1,"chunk-3a4b59cf":1,"chunk-00aff3dc":1,"chunk-739beacc":1,"chunk-76392eac":1,"chunk-09316e56":1,"chunk-0c208a24":1,"chunk-0cd3a036":1,"chunk-012a3980":1,"chunk-1e1b70ce":1,"chunk-28e0a6d8":1,"chunk-5d177b48":1,"chunk-34e639ce":1,"chunk-0eb28a83":1,"chunk-f4de09ea":1,"chunk-71dec82a":1,"chunk-74ecf879":1,"chunk-d8049c4e":1,"chunk-0ef001b7":1,"chunk-10f8e26c":1,"chunk-1a029487":1,"chunk-28d8687e":1,"chunk-73f106a2":1,"chunk-7d358f54":1,"chunk-ac36e800":1,"chunk-35091448":1,"chunk-4e3c30d6":1,"chunk-147c0f50":1,"chunk-2608d10c":1,"chunk-4bc4f5dd":1,"chunk-5873f342":1,"chunk-5a392a6d":1,"chunk-351ffa5a":1,"chunk-630c91a8":1,"chunk-5c19e750":1,"chunk-67b72cb9":1,"chunk-44d1996e":1,"chunk-13b66f3e":1,"chunk-0798af1c":1,"chunk-14f7ea66":1,"chunk-164c7626":1,"chunk-07164102":1,"chunk-526cb31d":1,"chunk-83fb632e":1,"chunk-1b7a2e22":1,"chunk-1d83229b":1,"chunk-1e857436":1,"chunk-1ff75b9c":1,"chunk-22ec8fae":1,"chunk-249cfae6":1,"chunk-28f60f38":1,"chunk-3011d30a":1,"chunk-31001712":1,"chunk-41eb90f0":1,"chunk-470f6c2e":1,"chunk-5d3dd47e":1,"chunk-5e6b1b7f":1,"chunk-6488a1af":1,"chunk-657f9006":1,"chunk-65c3803c":1,"chunk-65eabde3":1,"chunk-00c58462":1,"chunk-09c095d0":1,"chunk-09c2608b":1,"chunk-84886a88":1,"chunk-0feebfce":1,"chunk-1317f7ff":1,"chunk-15468e74":1,"chunk-3f024ec1":1,"chunk-23f8557c":1,"chunk-2a16855b":1,"chunk-417bd08e":1,"chunk-4b77a73a":1,"chunk-584ff47c":1,"chunk-6629aea1":1,"chunk-70dce6f7":1,"chunk-70f4c463":1,"chunk-7265886b":1,"chunk-7f2b860a":1,"chunk-875d1180":1,"chunk-a2594b04":1,"chunk-d4ee21da":1,"chunk-71310779":1,"chunk-8741dcfa":1,"chunk-7ada92d7":1,"chunk-7b35a887":1,"chunk-8a9cf9fe":1,"chunk-921365f2":1,"chunk-92a42972":1,"chunk-953cde5a":1,"chunk-a7961be2":1,"chunk-1613100e":1,"chunk-73f6c48b":1,"chunk-096579d6":1,"chunk-59f7bbd5":1,"chunk-ad88a7ca":1,"chunk-fc12ec66":1,"chunk-f405f72e":1,"chunk-00daf07a":1,"chunk-3e8da645":1,"chunk-7285809e":1,"chunk-ea7b0888":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddNewPlatform":"AddNewPlatform","ResetPassword":"ResetPassword","lang-ar-js":"lang-ar-js","lang-fr-js":"lang-fr-js"}[chunkId]||chunkId) + "." + {"AddNewPlatform":"31d6cfe0","ResetPassword":"e6809256","chunk-000f9ec6":"31d6cfe0","chunk-173ac372":"7c7e44ec","chunk-6c3750fe":"943ab50f","chunk-19ffec8b":"344a3d3f","chunk-0bc74327":"79890eb6","chunk-523ed891":"788b8037","chunk-5e39cf3e":"ea0a6270","chunk-65b468ae":"14b35398","chunk-c382173e":"c78df23a","chunk-3a4b59cf":"afd05b37","chunk-00aff3dc":"4516c9d9","chunk-2d0f1010":"31d6cfe0","chunk-739beacc":"4516c9d9","chunk-76392eac":"4516c9d9","chunk-09316e56":"726b3234","chunk-0c208a24":"ff3d539c","chunk-0cd3a036":"bafc95f3","chunk-012a3980":"90ea94d1","chunk-1e1b70ce":"d021f58e","chunk-28e0a6d8":"b393a940","chunk-5d177b48":"048382d8","chunk-34e639ce":"048382d8","chunk-0eb28a83":"97b968ae","chunk-f4de09ea":"54eb5bf0","chunk-71dec82a":"d66f86cf","chunk-74ecf879":"fdd5fbc0","chunk-d8049c4e":"8cf06977","chunk-0ef001b7":"b86c70b3","chunk-10f8e26c":"3c0a819d","chunk-1a029487":"ba50c393","chunk-28d8687e":"3ab95d6e","chunk-73f106a2":"533620c7","chunk-7d358f54":"9de20b79","chunk-ac36e800":"e467e7b4","chunk-35091448":"9196ef73","chunk-4e3c30d6":"27c09f4a","chunk-147c0f50":"60cdafe2","chunk-2608d10c":"79cd858a","chunk-4bc4f5dd":"fc3be584","chunk-5873f342":"e2b259e1","chunk-5a392a6d":"fc3be584","chunk-351ffa5a":"c7fb41a6","chunk-630c91a8":"d7b8002a","chunk-fbd596f6":"31d6cfe0","chunk-5c19e750":"42495c01","chunk-67b72cb9":"6e038945","chunk-44d1996e":"f5c6a289","chunk-13b66f3e":"6363a547","chunk-0798af1c":"90c9e7e1","chunk-14f7ea66":"e6809256","chunk-164c7626":"2ec48091","chunk-07164102":"2c9d316d","chunk-526cb31d":"a51cabb6","chunk-83fb632e":"f25c3144","chunk-1b7a2e22":"c637a89c","chunk-1d83229b":"7b25dda8","chunk-1e857436":"7c7e44ec","chunk-1ff75b9c":"37be0b97","chunk-22ec8fae":"7b25dda8","chunk-249cfae6":"9f0782a9","chunk-28f60f38":"7b25dda8","chunk-3011d30a":"7f2a0a13","chunk-31001712":"e6809256","chunk-41eb90f0":"178a552e","chunk-470f6c2e":"e6809256","chunk-59d985be":"31d6cfe0","chunk-5a0538ee":"31d6cfe0","chunk-5d3dd47e":"ff3d539c","chunk-5e6b1b7f":"a979a27b","chunk-6488a1af":"e6809256","chunk-657f9006":"ff3d539c","chunk-65c3803c":"7f2a0a13","chunk-65eabde3":"e374a099","chunk-00c58462":"ff21e328","chunk-020ee2cc":"31d6cfe0","chunk-0967a420":"31d6cfe0","chunk-096a7f28":"31d6cfe0","chunk-09c095d0":"4ed228ac","chunk-09c2608b":"458114b1","chunk-84886a88":"6a19e9cc","chunk-0feebfce":"7c7e44ec","chunk-1317f7ff":"9cc25f3d","chunk-15468e74":"726b3234","chunk-0a4396f5":"31d6cfe0","chunk-3f024ec1":"81e083a9","chunk-47feed04":"31d6cfe0","chunk-1af11311":"31d6cfe0","chunk-23f8557c":"f36f23bc","chunk-2a16855b":"2084efea","chunk-2d0c4c35":"31d6cfe0","chunk-2d0cfc48":"31d6cfe0","chunk-2d229624":"31d6cfe0","chunk-2d229bb6":"31d6cfe0","chunk-417bd08e":"eacf8de4","chunk-4b77a73a":"0ed1b1a4","chunk-584ff47c":"726b3234","chunk-5d8f1146":"31d6cfe0","chunk-6629aea1":"45639a41","chunk-70dce6f7":"7c7e44ec","chunk-70f4c463":"7c7e44ec","chunk-7265886b":"89290ed0","chunk-7f2b860a":"46c25e14","chunk-875d1180":"17ecf23d","chunk-a2594b04":"8abd55b7","chunk-d4ee21da":"b82c969a","chunk-ec8890b2":"31d6cfe0","chunk-ecb72392":"31d6cfe0","chunk-71310779":"be306d64","chunk-8741dcfa":"a4b8b023","chunk-e98f3c76":"31d6cfe0","chunk-7ada92d7":"ab87714c","chunk-7b35a887":"ff3d539c","chunk-8a9cf9fe":"7b25dda8","chunk-921365f2":"7f2a0a13","chunk-92a42972":"7a9a52e1","chunk-953cde5a":"e6809256","chunk-a7961be2":"8e375347","chunk-1613100e":"a0a84a88","chunk-73f6c48b":"163a1e7f","chunk-096579d6":"622b067b","chunk-59f7bbd5":"622b067b","chunk-ad88a7ca":"869a7088","chunk-fc12ec66":"87615114","chunk-f405f72e":"ff3d539c","chunk-00daf07a":"5609e321","chunk-3e8da645":"1fc767c6","chunk-7285809e":"4e8b1b9f","chunk-ea7b0888":"8e375347","lang-ar-js":"31d6cfe0","lang-fr-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
